import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { TErrorSearchProps } from 'open-search/types';
import { TextsSearchTrucker } from '../types';

export function useErrorSearchTrucker() {
  const { refetchSearch } = useOpenSearchContext();

  const propsErrorSearch: TErrorSearchProps = {
    tryAgainButtonProps: {
      states: { textContent: TextsSearchTrucker.textButtonTryAgain },
      events: {
        onClick: () => refetchSearch(),
      },
    },
  };

  return { propsErrorSearch };
}
